define('ContactUs.EnableRegistration.View', [
    'Backbone',
    'contact_us_enableregistration.tpl',
    'underscore',
    'Utils'
], function(
    Backbone,
    contactUsEnableregistrationTpl,
    _
) {
    ' use strict';

    return Backbone.View.extend({
        logInText: _.translate('Log In'),
        template: contactUsEnableregistrationTpl,
        initialize: function initialize(options) {
            this.layout = options.layout;
            this.hideRegister();
        },
        hideRegister: function hideRegister() {
            var self = this;
            this.layout.on('afterShowContent', function afterShowContent() {
                _.delay(function delayFn() {
                    document.title = self.logInText;
                    jQuery('.login-register-title').html(self.logInText);
                    jQuery('.login-register-wrapper-register').remove();
                });
            });
        }
    })
})
